import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import BrandForm from "../CreateBrand/BrandForm";
import { closeModalDialog } from "../../../../../../actions/layoutActions";
import propTypes from "../../../../../../constants/propTypes";
import {
  performUpdateRequest,
  setReload,
} from "../../../../../../actions/dataComponentActions";

import { LoaderContext } from "../../../../../ui/Loader";
import { getDataComponent } from "../../../../../../reducers/dataComponentReducer";
import { handleRequestError } from "../../../../../../utils/formValidationUtils";
import { processUpdateRequestStatus } from "../../../../../../utils/dataComponentUtils";
import { dataComponentId } from "../BrandsTableContainer";

const processRequestResponse = (
  prevDataComponent,
  dataComponent,
  closeModalDialog,
  setReload,
  formikActions
) => {
  processUpdateRequestStatus(prevDataComponent, dataComponent, {
    onSuccess: () => {
      closeModalDialog();
      setReload(dataComponentId, true);
    },
    onError: error => handleRequestError(error, formikActions),
  });
};

export const EditBrandContainer = ({
  dataComponent,
  closeModalDialog,
  brand,
  setReload,
  performUpdateRequest,
  loading,
}) => {
  const [prevDataComponent, setPrevDataComponent] = useState(dataComponent);
  const [formikActions, setFormikAction] = useState(null);

  useEffect(() => {
    setPrevDataComponent(dataComponent);
  }, [dataComponent]);

  useEffect(() => {
    processRequestResponse(
      prevDataComponent,
      dataComponent,
      closeModalDialog,
      setReload,
      formikActions
    );
  }, [
    closeModalDialog,
    dataComponent,
    formikActions,
    prevDataComponent,
    setReload,
  ]);

  const handleEditCode = useCallback(
    ({ flagsTotal, ...brand }, formikActions) => {
      performUpdateRequest(dataComponentId, brand.id, brand);
      setFormikAction(formikActions);
    },
    [performUpdateRequest]
  );

  const initialValues = {
    ...brand,
  };

  return (
    <LoaderContext.Provider value={{ loading }}>
      <BrandForm
        initialValues={initialValues}
        onSubmit={handleEditCode}
        dataComponentId={dataComponentId}
      />
    </LoaderContext.Provider>
  );
};

EditBrandContainer.propTypes = {
  dataComponent: propTypes.dataComponent,
  closeModalDialog: PropTypes.func,
  brand: propTypes.brand,
  performUpdateRequest: PropTypes.func,
  loading: PropTypes.bool,
  setReload: PropTypes.func,
};

export const mapDispatchToProps = {
  closeModalDialog,
  performUpdateRequest,
  setReload,
};

const mapStateToProps = state => {
  const dataComponent = getDataComponent(dataComponentId, state);
  return {
    dataComponent,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditBrandContainer);
